import { contact, isTodo, whatsappLink } from './content';
import { ChatIcon } from './icons';

/**
 * Opens a WhatsApp chat with us, the message already typed. While `contact.whatsapp` is a TODO it
 * renders a marked placeholder, never a link to a number that doesn't exist.
 */
export const WhatsAppButton = ({
  label,
  text,
  className = 'lp-btn lp-btn--chat',
}: {
  label: string;
  text: string;
  className?: string;
}) =>
  isTodo(contact.whatsapp) ? (
    <span className="lp-todo">
      {label} — {contact.whatsapp}
    </span>
  ) : (
    <a
      href={whatsappLink(contact.whatsapp, text)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      <ChatIcon />
      {label}
    </a>
  );
